"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (loadmoreButton, mixer, config) {
    if (!loadmoreButton || !mixer) {
        return function () { };
    }
    var updateLoadmore = function () {
        // @ts-ignore
        var limit = mixer.getState().activePagination.limit;
        // @ts-ignore
        var totalMatching = mixer.getState().totalMatching;
        if (limit > totalMatching) {
            loadmoreButton.classList.add('is-disabled');
            loadmoreButton.disabled = true;
        }
        else if (loadmoreButton.disabled) {
            loadmoreButton.classList.remove('is-disabled');
            loadmoreButton.disabled = false;
        }
    };
    // @ts-ignore
    if (mixer.getState().totalTargets < config.limit) {
        loadmoreButton.style.display = 'none';
    }
    loadmoreButton.addEventListener('click', function () {
        // @ts-ignore
        mixer.paginate({
            // @ts-ignore
            limit: mixer.getState().activePagination.limit + config.increment
        });
    });
    updateLoadmore();
    return updateLoadmore;
});
